import httpStore from '@storages/httpStore'
import appStore from '@storages/appStore'
import Vue from 'vue'
// import reportsData from './data/reportsData.json' // ZZZZ
// import dataset from './data/timeline.json' // ZZZZ
// import dataset from './data/test.json' // ZZZZ
// import dataset from './data/dataset1.json' // ZZZZ
// import dataset from './data/dataset2_all_reports.json' // ZZZZ
// import dataset from './data/class_example.json' // ZZZZ
// import child from './data/Anninskiy.json' // ZZZZ

export default {
  methods: {

    getBboxFromPolygonMix (polygon) {
      let xMin = 999
      let yMin = 999
      let xMax = 0
      let yMax = 0
      polygon.forEach(element => {
        if (element[0] < xMin) {
          xMin = element[0]
        }
        if (element[0] > xMax) {
          xMax = element[0]
        }
        if (element[1] < yMin) {
          yMin = element[1]
        }
        if (element[1] > yMax) {
          yMax = element[1]
        }
      })
      return [xMin, yMin, xMax, yMax]
    },

    refreshTokenMix (backUrl) {
      let _config = appStore.getters.value('config')
      if ('auth_api_url' in _config) {
        let _url = _config.auth_api_url + 'sessions/refresh'
        return Vue.http.get(_url)
      }
    },

    getChildMix (params) {
      let _url = httpStore.getters.host + httpStore.getters.orderById(params.orderId) + '?dict=' + params.dict + '&dict_item_parent_id=' + params.dictItemParentId
      return this.$http.get(_url)
    },

    getOrderByIdMix (orderId) {
      // если запрашиваем тестовый заказ(есть проблема. Если его выбрать вовремя прогрузки другого то получишь непредсказуемое поведение, так что проще вписать в url localhost:8080/44)
      // if (orderId === 44) { // ZZZZ
      //   return Promise.resolve({body: dataset})
      // }
      let _url = httpStore.getters.host + httpStore.getters.orderById(orderId)
      return this.$http.get(_url, {
        before (request) {
          if (this.previousRequest) {
            this.previousRequest.abort()
          }
          this.previousRequest = request
        }
      })
    },

    getOrdersMix () {
      let _url = httpStore.getters.host + httpStore.getters.value('orders')
      return this.$http.get(_url)
    },

    getDownloadPdfListMix (orderId) {
      let _url = httpStore.getters.host + httpStore.getters.pdfReports(orderId)
      return this.$http.get(_url)
      // return Promise.resolve({body: reportsData})
    },

    getProfileDataMix () {
      let _url = httpStore.getters.host.replace(appStore.getters.value('name') + '/', '') + httpStore.getters.value('profile')
      return this.$http.get(_url)
    },

    getProductsMix () {
      let _url = httpStore.getters.host + httpStore.getters.value('products')
      return this.$http.get(_url)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dataMix.js